import { IconTrashXFilled } from '@tabler/icons-react';

export default function EraseButtonRead({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Limpiar orden"
      title="Limpiar orden"
      className="flex items-center justify-center gap-1.5 shrink-0 h-11 px-4 rounded-full border-none cursor-pointer touch-manipulation select-none transition-all duration-200 ease-out active:scale-[0.97] [@media(hover:hover)]:hover:brightness-110"
      style={{
        backgroundColor: '#ff453a',
        boxShadow: '0 6px 18px rgba(255, 69, 58, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.18)',
        color: '#fff',
        fontSize: '13px',
        fontWeight: 600,
        fontFamily: '"Public Sans", sans-serif',
        letterSpacing: '-0.01em',
      }}
    >
      <IconTrashXFilled size={15} color="#fff" />
      Limpiar
    </button>
  );
}
